import React from "react";
import resume from "../../images/resume-converted.pdf";
import mainbackground from '../../images/mainbackground.jpg'

const Resume = () => (

  <div className="resume" style={{backgroundImage:`url(${mainbackground})`}} >
    <h1 className="resume-title">Proficiencies</h1>
    <a href='https://www.jjlaw.info' className="resume-text-link" style={{fontFamily:"times new roman", fontSize:"22px"}}>
      {"    "} In addition, visit my tech law blog here ....
    </a>
    <ul className="resume-text">
      <p>Front-end Proficiencies</p>
      <li className="resume-text-span">HTML</li>
      <li className="resume-text-span">CSS</li>
      <li className="resume-text-span">JavaScript</li>
      <li className="resume-text-span">JQuery</li>
      <li className="resume-text-span">Bootstrap</li>
      <li className="resume-text-span">Responsive Desgin</li>
      <li className="resume-text-span">REACT</li>
      <br/>
      <p>Back-end Proficiencies</p>
      <li className="resume-text-span">Node.js</li>
      <li className="resume-text-span">Express.js</li>
      <li className="resume-text-span">MySQL</li>
      <li className="resume-text-span">MongoDB</li>
      <li className="resume-text-span">MVC structure</li>
      
    </ul>
  </div>
);

export default Resume;
